import initialApplicationState from './application/state/initialState.js';
import initialSetupCompanyState from './setupCompany/state/initialState.js';
import initialLoanState from './loan/state/initialState.js';
import initialUserState from './user/state/initialState';
import initialHmdaState from './hmda/state/initialState';
import initialBorrowerState from './borrower/initialState';
import initialTemplateState from './templates/initialState';
import initialNoticeState from './notices/initialState';
import initialInspectionState from './inspections/initialState';
import initialExperienceState from './experiences/initialState';
import initialAdminState from './adminUsers/initialState.js';
import watchlistInitialState from './watchlists/initialState.js';
import lendingLimitInitialState from './lendinglimits/initialState.js';

export default {
    app: {
        error: {
            status: false,
            message: '',
        },
        loading: {
            status: false,
            message: '',
        },
    },
    drawState: {
        toggleArray: [],
        drawTotal: 0,
    },
    user: initialUserState,
    bfiUser: {
        authenticated: false,
        admin: false,
        isSuper: false,
        isBroker: false,
        areTermsAccepted: false,
        broker: {},
        userId: null,
        companies: [],
        refreshToken: null,
        ffinuser: null,
        ffincompany: null,
        expires: 0,
        ignoringEsignThisSession: false,
    },
    modals: {
        esign: false,
        esignCanWithdraw: false,
        esignData: null,
    },
    brokerState: {
        openBrokerModal: false,
        brokerId: null,
        searchText: undefined,
        deleteIncompleteRegisteredBrokerModal: {
            isOpen: false,
            userId: 0,
        },
    },
    brokerClientState: {
        openBrokerClientModal: false,
        brokerClientId: null,
        searchBrokerClientText: undefined,
    },
    iccaState: {
        openIccaModal: false,
        iccaId: null,
    },
    searchState: {
        searchText: {
            application: '',
            appraise: '',
            broker: '',
            brokerClient: '',
            loan: '',
            adminUser: '',
            principalUser: '',
            brokerUser: '',
            generalContractorUser: '',
        },
    },
    setupCompany: {
        ...initialSetupCompanyState,
    },
    application: { ...initialApplicationState },
    snackbar: {
        isOpen: false,
        message: undefined,
        variant: 'info',
    },
    appraisers: {
        appraiserModal: {
            isOpen: false,
            appraiserId: 0,
        },
        deleteAppraiserModal: {
            isOpen: false,
            appraiserId: 0,
        },
        restoreAppraiserModal: {
            isOpen: false,
            appraiserId: 0,
        },
    },
    loan: { ...initialLoanState },
    hmda: { ...initialHmdaState },
    borrower: { ...initialBorrowerState },
    templates: { ...initialTemplateState },
    notices: { ...initialNoticeState },
    inspections: { ...initialInspectionState },
    levels: {
        levelModal: {
            isOpen: false,
            levelId: 0,
        },
    },
    rules: {
        ruleModal: {
            isOpen: false,
            ruleId: 0,
        },
        supplementalruleModal: {
            isOpen: false,
            supplementalRuleId: 0,
        },
    },
    experiences: { ...initialExperienceState },
    adminUsers: { ...initialAdminState },
    watchlists: { ...watchlistInitialState },
    lendingLimit: { ...lendingLimitInitialState },
};
